import { getUrlDefaults } from '~/src/Lib/Nav'

const urls = getUrlDefaults('recipes')

export default urls
